import { RANGE, TAB } from "./constants";
import { is } from "ramda";

export const changeTab = payload => {
  return {
    type: TAB,
    payload: is(String, payload) ? { currentTab: payload } : payload
  };
};

export const changeDates = payload => {
  return {
    type: RANGE,
    // payload: is(String, payload) ? { currentTab: payload } : payload
    payload
  };
};
